// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__ul2xR","footer":"ChangeClinic_footer__iu67V"};